import { FC } from 'react';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { UIModal } from '@/components/ui/Modal';
import { Typography } from '@/components/ui/Typography';
import { UIBox } from '@/components/ui/Box';
import { palette } from '@/theme';

type ModalBoxesProps = {
  open: boolean;
  onClose: () => void;
  deliveryCode: string;
  boxes: string[];
};

const StyledWrapper = styled(UIBox)`
  width: 100%;
  height: 100%;
  padding: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StyledCloseIcon = styled(IconButton)`
  position: absolute;
  top: 12px;
  right: 12px;

  svg {
    fill: ${palette.colors.primary};
  }
`;

const StyledHeader = styled(UIBox)`
  flex-direction: column;
  flex-shrink: 0;
  padding-right: 32px;
`;

const StyledBoxesCount = styled(Typography)`
  margin-top: 4px;
`;

const StyledScrollArea = styled.div`
  margin-top: 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

const StyledBoxItem = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }
`;

const ModalBoxes: FC<ModalBoxesProps> = ({
  open,
  onClose,
  deliveryCode,
  boxes,
}) => {
  return (
    <UIModal
      open={open}
      onClose={onClose}
      $minWidth="360px"
      $width="360px"
      $height="320px"
      $maxHeight="320px"
    >
      <StyledWrapper>
        <StyledCloseIcon onClick={onClose} aria-label="close modal">
          <HighlightOffIcon color={'primary'}/>
        </StyledCloseIcon>

        <StyledHeader>
          <Typography font="heavy" size="lg">
            Delivery {deliveryCode}
          </Typography>
          <StyledBoxesCount font="book" size="sm" color="grey">
            {boxes.length} boxes
          </StyledBoxesCount>
        </StyledHeader>

        <StyledScrollArea>
          {boxes.map((box, index) => (
            <StyledBoxItem key={`${box}-${index}`}>
              <Typography font="book" size="sm">
                {box}
              </Typography>
            </StyledBoxItem>
          ))}
        </StyledScrollArea>
      </StyledWrapper>
    </UIModal>
  );
};

export default ModalBoxes;
